<main fxLayout="column">
  <div *ngIf="loading" fxLayoutAlign="center center" style="height: 250px">
    <mat-spinner [diameter]="25" strokeWidth="3" color="accent"></mat-spinner>
  </div>

  <div *ngIf="!loading" fxLayoutAlign="center center" tabindex="0">
    <div *ngIf="loginForm && loginConfig" fxLayout="column" class="login-card">
      <!-- Login Form -->
      <form [formGroup]="loginForm">
        <!-- Login Instructions  -->
        <div fxLayout="row" style="margin-bottom: 1.75rem">
          <div [innerHTML]="loginConfig.loginInstructionalText"></div>
        </div>
        <!-- Library List Autocomplete -->
        <div *ngIf="loginConfig.showLibraryLookupBox" fxLayout="row">
          <mat-form-field *ngIf="libraries.length; else singleLid" fxFlex="100">
            <mat-label>Select Your Library</mat-label>
            <input
              #libraryInput
              matInput
              type="text"
              placeholder="Select Your Library"
              [formControl]="librariesControl"
              [matAutocomplete]="auto"
              (focus)="onInputFocus()"
            />
            <button mat-icon-button matSuffix type="button" (click)="clearLibraryInput($event)">
              <mat-icon>{{ librariesControl.value ? 'clear' : 'keyboard_arrow_down' }}</mat-icon>
            </button>
            <mat-autocomplete
              #auto="matAutocomplete"
              autoActiveFirstOption
              autoSelectActiveOption
              (optionSelected)="onLibraryOptionSelected($event)"
            >
              <mat-option *ngFor="let option of filteredLibraryOptions | async" [value]="option">
                {{ option }}
              </mat-option>
            </mat-autocomplete>

            <mat-error *ngIf="librariesControl.invalid && !librariesControl.pristine"
              >Please select a library</mat-error
            >
          </mat-form-field>

          <ng-template #singleLid>
            <mat-form-field fxFlex="100">
              <mat-label>Your Library</mat-label>
              <input matInput type="text" readonly [formControl]="librariesControl" />
            </mat-form-field>
          </ng-template>
        </div>

        <!-- User and Password -->
        <div fxLayout="row">
          <mat-form-field fxFlex="100">
            <input
              #userName
              agAutofocus
              matInput
              id="username"
              type="text"
              formControlName="user"
              title="User Name"
              autocomplete="on"
              [placeholder]="loginConfig.userNameLabel"
            />
          </mat-form-field>
        </div>
        <div fxLayout="row">
          <mat-form-field fxFlex="100">
            <input
              matInput
              id="password"
              type="password"
              formControlName="password"
              autocomplete="off"
              title="Password"
              [placeholder]="loginConfig.showPasswordPrompt ? loginConfig.passwordLabel : ''"
            />
          </mat-form-field>
        </div>

        <!-- Remember Me / Forget Your Password -->
        <div fxLayout="row" class="font-0-8" fxLayoutGap="10px" fxLayoutAlign="space-between">
          <mat-checkbox
            fxLayout="column"
            fxLayout.xs="row"
            fxflex="50"
            fxLayout.xs="100"
            formControlName="remember"
          >
            Remember Me?
          </mat-checkbox>
          <button
            *ngIf="loginConfig.showForgotPasswordLink"
            fxLayout="column"
            fxLayout.xs="row"
            fxflex="50"
            fxLayout.xs="100"
            mat-button
            type="button"
            (agInteract)="forgotPassword()"
          >
            Forgot Your Password
          </button>
        </div>

        <!-- Self Registration -->
        <div
          *ngIf="userData.allowSelfRegistration"
          fxLayout="row"
          fxLayoutGap="10px"
          class="font-0-8"
        >
          <button
            mat-button
            fxLayout="column"
            fxLayoutAlign="start"
            class="overflow-btn"
            type="button"
            (agInteract)="signUp()"
          >
            {{ userData.selfRegistrationLabel }}
          </button>
        </div>

        <!-- Submit and Clear -->
        <div fxLayout="row" fxLayoutAlign="end">
          <button
            mat-button
            role="button"
            type="submit"
            aria-label="Submit"
            class="ag-mat-button-primary"
            [disabled]="loginForm.invalid"
            (click)="loginSubmit()"
          >
            <span *ngIf="!btnLoading" style="width: 175px">Submit</span>
            <mat-icon *ngIf="btnLoading">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
          </button>
          <button
            mat-button
            role="button"
            aria-label="Cancel"
            type="button"
            style="margin-left: 10px"
            (click)="goToHome()"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</main>
